import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase';
import { createStatsData } from '../../utils/createStatsData';
const reportId = 'payment_method_used';
export const usePaymentMethodUsedReportCard = () => {
    const analyticsCardBase = useAnalyticsCardBase({
        reportId,
    });
    const data = createStatsData({
        rows: analyticsCardBase.reportData?.report?.rows,
        mapFn: (row) => ({
            label: row.payment_method,
            value: row.percentage,
        }),
    });
    return {
        ...analyticsCardBase,
        type: 'barStats',
        data,
    };
};
